import styled from 'styled-components'
import { Styles as BaseStyles } from '~/pages/anatomy/quizBinaryChoice/libs/styles'

type TCardColors = {
  secondBehind: string
  firstBehind: string
  front: string
}

export const createCardLayoutStyles = ({
  secondBehind,
  firstBehind,
  front,
}: TCardColors) => ({
  ...BaseStyles,

  Question: styled(BaseStyles.Question)`
    margin-bottom: 36px;
  `,

  CardWrapper: styled.div`
    position: relative;

    &::before {
      content: '';
      position: absolute;
      top: -20px;
      left: 50%;
      transform: translateX(-50%);
      width: 311px;
      height: 60px;
      background: ${secondBehind};
      border: 1px solid #e3dcfb;
      border-radius: 12px;
      z-index: 0;
    }

    &::after {
      content: '';
      position: absolute;
      top: -12px;
      left: 50%;
      transform: translateX(-50%);
      width: 327px;
      height: 60px;
      background: ${firstBehind};
      border: 1px solid #e3dcfb;
      border-radius: 12px;
      z-index: 1;
    }
  `,

  Card: styled.div`
    position: relative;
    background: ${front};
    border: 1px solid #e3dcfb;
    border-radius: 12px;
    box-shadow: 0 4px 10px 0 rgba(62, 11, 143, 0.1);
    overflow: hidden;
    z-index: 2;
    text-align: center;
    padding: 12px;
  `,

  ImageBackground: styled.div`
    width: 100%;
    margin-bottom: 16px;

    picture {
      display: block;
    }

    img {
      width: 100%;
      display: block;
    }
  `,

  CardTextContent: styled.div``,

  CardTitle: styled.h2`
    color: #000;
    font-size: 22px;
    line-height: 1;
    font-weight: 700;
    margin-bottom: 8px;
  `,

  CardSubtitle: styled.p`
    color: #000;
    font-size: 14px;
    line-height: 1.2;
  `,

  ButtonWrapper: styled(BaseStyles.ButtonWrapper)`
    margin-top: 16px;
  `,
})
